"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Delete = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const Delete_1 = require("@reactionable/core/lib/crud/delete/Delete");
const Button_1 = tslib_1.__importDefault(require("react-bootstrap/Button"));
const Icon_1 = require("../../icon/Icon");
function Delete(_a) {
    var { label, icon = { icon: free_solid_svg_icons_1.faTrashAlt } } = _a, props = tslib_1.__rest(_a, ["label", "icon"]);
    return (jsx_runtime_1.jsx(Delete_1.Delete, Object.assign({}, props, { children: jsx_runtime_1.jsxs(Button_1.default, Object.assign({ variant: "danger", title: props.title || "" }, { children: [icon && jsx_runtime_1.jsx(Icon_1.Icon, Object.assign({ className: label ? "mr-2" : "" }, icon), void 0), label] }), void 0) }), void 0));
}
exports.Delete = Delete;
//# sourceMappingURL=Delete.js.map